export default __webpack_public_path__ + "static/media/settings.3df0a65e.svg";